<template>
  <div class="conversation-opportunities--panel">
    <opportunity-summary-list
      :opportunities="opportunities"
      :is-loading="isFetching"
      :has-error="hasError"
      :empty-message="$t('CONTACT_PANEL.OPPORTUNITIES.NO_RECORDS_FOUND')"
    />
  </div>
</template>

<script>
import OpportunitySummaryList from '../opportunities/components/OpportunitySummaryList';

export default {
  components: {
    OpportunitySummaryList,
  },
  props: {
    conversationId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      opportunities: [],
      isFetching: false,
      hasError: false,
    };
  },
  watch: {
    conversationId(newConversationId, prevConversationId) {
      if (newConversationId && newConversationId !== prevConversationId) {
        this.fetchOpportunities();
      }
    },
  },
  mounted() {
    this.fetchOpportunities();
    window.bus.$on('opportunity_created', this.fetchOpportunities);
  },
  beforeDestroy() {
    window.bus.$off('opportunity_created', this.fetchOpportunities);
  },
  methods: {
    async fetchOpportunities() {
      // Snapshot the conversation this fetch is for. A quick switch between
      // two conversations can fire a second fetch before the first one
      // resolves - if the first (now stale) response lands after the
      // second, it must not be allowed to overwrite the list with another
      // conversation's opportunities (this caused the "Últimas
      // oportunidades" link routing to the wrong opportunity/conversation
      // reported in MARVEL-1534).
      const requestedConversationId = this.conversationId;

      if (!requestedConversationId) {
        this.opportunities = [];
        return;
      }

      this.isFetching = true;
      this.hasError = false;
      try {
        const result =
          (await this.$store.dispatch('opportunities/list', {
            conversation_id: requestedConversationId,
          })) || [];
        if (requestedConversationId !== this.conversationId) return;
        this.opportunities = result;
      } catch (error) {
        if (requestedConversationId === this.conversationId) {
          this.opportunities = [];
          this.hasError = true;
        }
      } finally {
        if (requestedConversationId === this.conversationId) {
          this.isFetching = false;
        }
      }
    },
  },
};
</script>
